var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductLoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 277,
    height: 260,
    viewBox: "0 0 277 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6297",
    "data-name": "Grupo 6297",
    transform: "translate(-681 -1056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_894",
    "data-name": "Ret\\xE2ngulo 894",
    d: "M9,0H268a9,9,0,0,1,9,9V260a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V9A9,9,0,0,1,9,0Z",
    transform: "translate(681 1056)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_3d_delivery_box_parcel",
    "data-name": "3d_delivery_box_parcel",
    transform: "translate(438.027 988.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "objects",
    transform: "translate(325.795 139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6277",
    "data-name": "Grupo 6277",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1407",
    "data-name": "Caminho 1407",
    d: "M434.964,1271.626,385,1296.811a7.838,7.838,0,0,1-7.057,0l-18.724-9.439-14.553-7.335-16.685-8.411a3.977,3.977,0,0,1,0-7.1l49.962-25.185a7.837,7.837,0,0,1,7.057,0l49.962,25.185a3.977,3.977,0,0,1,0,7.1Z",
    transform: "translate(-325.795 -1159.428)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6276",
    "data-name": "Grupo 6276",
    transform: "translate(1.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1408",
    "data-name": "Caminho 1408",
    d: "M456.3,164.28l-48.244-24.457a7.577,7.577,0,0,0-6.822-.015l-48.354,24.237a3.8,3.8,0,0,0-2.122,3.428h0l-.137,60.359a3.8,3.8,0,0,0,2.106,3.438l48.244,24.457a7.574,7.574,0,0,0,6.822.015L456.147,231.5a3.8,3.8,0,0,0,2.121-3.428l.137-60.359a3.8,3.8,0,0,0-2.106-3.438Z",
    transform: "translate(-350.62 -139.004)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1409",
    "data-name": "Caminho 1409",
    d: "M1153.824,536.57v60.36a3.8,3.8,0,0,1-2.114,3.433l-48.3,24.347a7.575,7.575,0,0,1-3.411.811V536.57Z",
    transform: "translate(-1046.107 -507.978)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1410",
    "data-name": "Caminho 1410",
    d: "M457.1,171.024l-48.3,24.347a7.577,7.577,0,0,1-6.822,0l-18.1-9.125-14.069-7.092-16.13-8.131a3.844,3.844,0,0,1,0-6.866l48.3-24.347a7.577,7.577,0,0,1,6.822,0l48.3,24.347A3.845,3.845,0,0,1,457.1,171.024Z",
    transform: "translate(-351.499 -139)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1411",
    "data-name": "Caminho 1411",
    d: "M677.839,294.262l-58.52,29.5-14.069-7.092,58.521-29.5Z",
    transform: "translate(-586.938 -276.514)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1412",
    "data-name": "Caminho 1412",
    d: "M619.319,704.452v28.766l-14.069-7.092V697.36Z",
    transform: "translate(-586.938 -657.205)",
    fill: "#cfcfcf"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLoad);
export default __webpack_public_path__ + "static/media/product-load.66584acbde724ae377b71796384b0bff.svg";
export { ForwardRef as ReactComponent };